var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"data-test-tag":"ts-nps-overall"}},[_c('TsNpsCurrentGroupV2'),_c('TsNpsInfo',{attrs:{"is-mobile":_vm.isMobile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }